import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["getHeaderTitle", "actionMetadata", "flowObjectTypeId", "actionId"];
import PropTypes from 'prop-types';
// @ts-expect-error untyped module customer-data-objects-ui-components
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import EmailNotificationActionSummary from 'automation-ui-action-features/actions/email-notification/EmailNotificationActionSummary';
import EmailNotificationActionMetadata from 'automation-ui-action-features/actions/email-notification/EmailNotificationActionMetadata';
import { jsx as _jsx } from "react/jsx-runtime";
function EmailNotificationActionCard(_ref) {
  let {
      getHeaderTitle,
      actionMetadata,
      flowObjectTypeId,
      actionId
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, rest, {
    headerTitle: getHeaderTitle({
      actionId
    }),
    content: /*#__PURE__*/_jsx(EmailNotificationActionSummary, {
      actionMetadata: actionMetadata,
      flowObjectTypeId: flowObjectTypeId
    })
  }));
}
EmailNotificationActionCard.propTypes = {
  getHeaderTitle: PropTypes.func.isRequired,
  actionMetadata: PropTypes.instanceOf(EmailNotificationActionMetadata).isRequired,
  flowObjectTypeId: ObjectTypeIdType,
  actionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default EmailNotificationActionCard;